import { render, staticRenderFns } from "./tr-list.vue?vue&type=template&id=ccbcd470&"
import script from "./tr-list.vue?vue&type=script&lang=js&"
export * from "./tr-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports